import FileService from "@services/File";
import Service from "@services/Service";
import Settings from "@settings";
import { WEB_API_ENDPOINT, MESSAGE_BUCKET } from "@utils/awsAmplify";
import { download } from "@utils/browser";

class Message extends Service {
  static send(requests) {
    return new Promise((resolve, reject) => {
      const promises = requests.map((request) =>
        Message.post(WEB_API_ENDPOINT, "/outbound_message_batch", {
          body: request,
        })
      );

      Promise.all(promises)
        .then(() => {
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
    });
  }

  static sendWithFile(requests, file, fullFileName) {
    return new Promise((resolve, reject) => {
      const bucket = Settings.awsAmplify.Storage[MESSAGE_BUCKET];
      if (bucket) {
        FileService.exists(bucket, fullFileName).then((exists) => {
          if (!exists) {
            FileService.upload(bucket, file, fullFileName)
              .then(() => {
                Message.send(requests)
                  .then((response) => {
                    resolve(response);
                  })
                  .catch((e) => {
                    reject(e);
                  });
              })
              .catch((e) => {
                console.error(e);
                reject("File upload error");
              });
          } else {
            reject("Duplicate file");
          }
        });
      } else {
        reject("AWS S3 bucket not configured");
      }
    });
  }

  static downloadFile(fileName) {
    return new Promise((resolve, reject) => {
      const bucket = Settings.awsAmplify.Storage[MESSAGE_BUCKET];
      if (bucket) {
        FileService.download(bucket, fileName)
          .then((fileURL) => {
            download(fileURL, fileName)
              .then(() => {
                resolve();
              })
              .catch((e) => {
                reject(e);
              });
          })
          .catch((e) => {
            reject(e);
          });
      } else {
        reject("AWS S3 bucket not configured");
      }
    });
  }
}

export default Message;
